import Util from '@/util'

export function isColorLight(hex = '#ffffff') {
  // Convert hex to RGB
  const { r, g, b } = Util.hexToRgb(hex)

  // Calculate relative luminance (per WCAG standards)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  // Return true if the color is light, false if dark
  return luminance > 0.5
}
